import React from 'react';
import { Typography, Stack, Box } from '@mui/material';
import OptionsImage from 'url:./ProcessOverviewImages/PackReviewOptions.png';
import FeedbackReceivedImage from 'url:./ProcessOverviewImages/FeedbackReceived.png';
import WasteEstimatesImage from 'url:./ProcessOverviewImages/WasteEstimates.png';

function ProcessOverviewContent() {
    return (
        <Stack spacing={3} sx={{ py: 1 }}>
            <Typography variant="normal">
                Here is a brief overview of the process for physician pack review:
            </Typography>

            {/* Section 1 */}
            <Stack spacing={1}>
                <Typography variant="heavy">
                    1. DOCSI surveys physicians who commonly use the pack
                </Typography>
                <Typography variant="normal">
                    The physician is asked to provide feedback regarding how often they use each item in the pack
                </Typography>
                <Box
                    component="img"
                    src={OptionsImage}
                    alt="Pack item survey options"
                    sx={{ width: '100%', maxWidth: 450 }}
                />
            </Stack>

            {/* Section 2 */}
            <Stack spacing={1}>
                <Typography variant="heavy">
                    2. Physicians provide feedback on each pack item
                </Typography>
                <Typography variant="normal">
                    Physicians estimate how often they use each item in the pack:
                </Typography>
                <Box component="ul" sx={{ m: 0, pl: 3 }}>
                    <li><Typography variant="normal">Always ({'>'} 95%)</Typography></li>
                    <li><Typography variant="normal">Often (50-95%)</Typography></li>
                    <li><Typography variant="normal">Rarely (20-50%)</Typography></li>
                    <li><Typography variant="normal">Never ({'<'} 20%)</Typography></li>
                </Box>
                <Box
                    component="img"
                    src={FeedbackReceivedImage}
                    alt="Feedback received confirmation"
                    sx={{ width: '100%', maxWidth: 450 }}
                />
            </Stack>

            {/* Section 3 */}
            <Stack spacing={1}>
                <Typography variant="heavy">
                    3. DOCSI provides usage & waste estimates for each pack item
                </Typography>
                <Typography variant="normal">
                    DOCSI uses the physicians' feedback — along with how many cases each physician performs — to estimate how often each pack item goes unused when the pack is opened. These estimates are shown as low, medium, and high ranges.
                </Typography>
                <Box
                    component="img"
                    src={WasteEstimatesImage}
                    alt="Waste estimate table"
                    sx={{ width: '100%', maxWidth: 450 }}
                />
            </Stack>
        </Stack>
    );
}

export default ProcessOverviewContent;
